import type { IUser } from "@bbj-types/user";
import type { UserType } from "@bbj-types/user/enum";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axiosUser } from "./axios";

interface IPostUserBody {
  firstName: string;
  lastName: string;
  position?: string | null;
  email: string;
  phone?: string;
  organisations: {
    organisation: ObjectId;
    isMaster: boolean;
    roleV2: ObjectId;
    teams?: ObjectId[];
  }[];
}

export const usePostUser = () => {
  const [state, execute, cancel] = axiosUser<IUser, IPostUserBody, unknown>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: IPostUserBody, type: UserType) => {
      return execute({
        data,
        url: `/${type}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
